import { render, staticRenderFns } from "./HeadingInfo.vue?vue&type=template&id=5b0a6465&scoped=true"
import script from "./HeadingInfo.vue?vue&type=script&lang=js"
export * from "./HeadingInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0a6465",
  null
  
)

export default component.exports